<template>
  <div class="game-assets-data-table">
    <q-table
      :title="tableTitle"
      :data="tableData"
      :columns="columns"
      row-key="name"
      :pagination="pagination"
      :filter="search"
      virtual-scroll
      flat
      ><template v-slot:top-right>
        <q-input
          borderless
          dense
          debounce="500"
          v-model="search"
          placeholder="Search"
          outlined
          rounded
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template v-slot:body-cell-link="props">
        <q-td :props="props">
          <q-btn
            unelevated
            no-caps
            color="secondary"
            label="View"
            size="md"
            @click="handleProviderButtonClick(props.key, props.value)"
          ></q-btn>
        </q-td>
      </template>
    </q-table>
  </div>
</template>

<script>
export default {
  name: "GameAssetsDataTable",
  props: {
    tableData: Array,
    tableTitle: String,
    tableRowsPerPage: Number,
    tableSortByKey: String,
    tableDescending: Boolean,
  },
  data() {
    return {
      search: "",
      pagination: {
        sortBy: this.tableSortByKey,
        descending: this.tableDescending,
        page: 1,
        rowsPerPage: this.tableRowsPerPage,
      },
      columns: [
        {
          name: "name",
          label: "Provider",
          required: true,
          align: "left",
          field: (row) => row.name,
          format: (val) => `${val}`,
          sortable: true,
        },
        {
          name: "link",
          align: "right",
          field: "link",
        },
      ],
    };
  },
  methods: {
    handleProviderButtonClick(key, url) {
      this.$emit("providerClicked", key, url);
    },
  },
};
</script>
<style lang="scss" scoped>
.game-assets-data-table {
  box-shadow: 0px 4px 15px 5px rgba(0, 0, 0, 0.05);
}
</style>
